import { useQuery } from "@tanstack/vue-query";

import contractBuilderService from "@/services/modules/contractBuilder";

import type { ContractBuilderViewParams } from "@/models/contractBuilder";
import type { Ref } from "vue";

export const CONTRACTS_QUERY_KEYS = {
  ROOT: "contracts",
  INDEX: "contracts-index",
} as const;

export const useContractsIndexQuery = (
  searchParams?: Ref<ContractBuilderViewParams>
) => {
  return useQuery({
    queryKey: [
      CONTRACTS_QUERY_KEYS.ROOT,
      CONTRACTS_QUERY_KEYS.INDEX,
      searchParams,
    ],
    queryFn: async () => {
      return await contractBuilderService.getContractTemplates({
        ...searchParams?.value,
      });
    },
    staleTime: Infinity,
  });
};
